import React, { Component } from 'react';
import b from 'b_';
import { AppDataProps, withAppData } from 'client/contexts/appData';

import './footer.css';

const feedbackUrl = 'https://feedback2.yandex.ru/events/';
const organizationHelpUrl = 'https://feedback2.yandex.ru/events/';

type Props = AppDataProps;

const class_ = b.with('footer');

class Footer extends Component<Props> {
    render() {
        const { socialNetworks } = this.props.appData.cfg;

        return (
            <div className={class_()}>
                <div className={class_('blocks')}>
                    <div className={class_('blocks-item')}>
                        Если вы нашли ошибку,<br />пожалуйста,&nbsp;
                        <a target="_blank" rel="noopener noreferrer" href={feedbackUrl}>сообщите</a>&nbsp;
                        нам о ней.
                    </div>
                    <div>
                        Яндекс может помочь<br />
                        с проведением вашего мероприятия.
                        <div>
                            <a
                                href={organizationHelpUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={class_('organization-help-button')}
                            >
                                Подробности
                            </a>
                        </div>
                    </div>
                    <div>
                        Подпишитесь:
                        <div className={class_('social')}>
                            {socialNetworks.map(({ type, url }) => (
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    key={type}
                                    href={url}
                                    className={class_('social-item', { type })}
                                />
                            ))}
                        </div>
                    </div>
                    <div>
                        Видеоматериалы доступны по лицензии<br />
                        <a
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://creativecommons.org/licenses/by-nc/3.0/legalcode"
                        >
                            CC BY-NC 3.0
                        </a>&nbsp;
                        с обязательным указанием:<br />
                        © ООО «<a href="https://www.yandex.ru/">Яндекс</a>»
                    </div>
                </div>
            </div>
        );
    }
}

export default withAppData(Footer);
